import { Skeleton } from '@avanta/shared/components/ui/Skeleton';

const FIELD_IDS = ['code', 'contract', 'sickLeaveStart'];

export const ActivePatientRecordSkeleton = (): React.ReactElement => (
  <div className="grid grid-cols-3 gap-6" aria-hidden="true">
    {FIELD_IDS.map(id => (
      <div key={id} className="flex flex-col gap-2">
        <Skeleton className="h-3.5 w-24" />
        <Skeleton className="h-10 w-full rounded-lg" />
      </div>
    ))}
  </div>
);
